import {stateData, reduxState} from '../../values';

export const getInvoice = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_invoice,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateInvoice = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_invoice,
            payload:    data,
        })
    }
}

export const reDonwloading = () =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.re_downloading
        })
    }
}

export const filterInvoiceData = (data, option) =>{
    return(dispatch) =>{
        dispatch({
            type:           reduxState.filter_invoice,
            payload:        data,
            statusSearch:   option
        })
    }
}